<template>
	<div
		class="option-nav-wrapper"
		:class="{ 'sticky-on': stickyEnabled, 'is-sticky': isSticky }"
		:style="{ top: `${stickyOffset}px` }"
	>
		<nav class="option-nav">
			<button
				v-if="this.options.length >= 2"
				class="filter"
				@click="openFilterModal"
			>
				<i class="sk-icon-list-ul-solid"></i>
			</button>

			<div class="option-nav-list sk-scrollbar" ref="menuNavbar">
				<div
					:ref="`menuNavbarOption${option.id}`"
					@click="optionSelected(option)"
					class="option-item"
					v-for="option in options"
					:key="option.id"
					:class="{
						selected: option.selected
					}"
					v-html="option.text"
				></div>
			</div>
		</nav>
		<FilterModal ref="filterModal" @tabClicked="optionSelected" />
	</div>
</template>

<style scoped>
.option-nav-wrapper {
	height: 50px;
}

.option-nav-wrapper.sticky-on {
	position: sticky;
	z-index: 1;
}

.option-nav-wrapper.is-sticky {
	height: 0;
}

.filter {
	background: var(--gR-white);
	padding: 0 15px 0 15px;
	font-size: 12px;
}

.option-nav {
	height: 50px;
	background: var(--gR-white);
	box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25);
	padding: 0 20px;
	display: flex;
	align-items: center;
}

.option-nav-list {
	white-space: nowrap;
	overflow-x: scroll;
}

.option-nav::-webkit-scrollbar {
	height: 0;
}

.option-nav-wrapper.is-sticky .option-nav {
	opacity: 0;
	transition: opacity 0.25s ease-in;
	pointer-events: none;
}

.option-nav-wrapper.sticky-on .option-nav {
	opacity: 1;
	pointer-events: all;
}

.option-item {
	display: inline-block;
	font-size: 14px;
	color: var(--gR-base-80);
	height: 50px;
	line-height: 50px;
	vertical-align: middle;
	cursor: pointer;
}

.option-item.selected {
	font-weight: 600;
	border-bottom: 3px solid var(--gR-base-80);
}

.option-item + .option-item {
	margin-left: 25px;
}

.option-item:last-child {
	margin-right: 20px;
}

@media (max-width: 500px) {
	.option-item:first-child {
		margin-left: 20px;
	}

	.option-nav {
		padding: 0;
	}
}
</style>

<script>
import FilterModal from "@/components/modals/FilterModal.vue"
export default {
	name: "HorizontalNavbar",
	props: {
		options: Array,
		stickyEnabled: Boolean,
		isSticky: Boolean,
		stickyOffset: {
			type: Number,
			default: 50
		}
	},
	components: {
		FilterModal
	},
	computed: {
		selectedOption() {
			return this.options
				? this.options.find((option) => option.selected)
				: null
		}
	},
	methods: {
		optionSelected(option) {
			if (this.selectedOption && option.id == this.selectedOption.id) {
				return
			}

			this.scrollToSelectedOption(option)
			this.$emit("optionSelected", option)
		},
		scrollToSelectedOption(option) {
			if (option) {
				const optionRef = this.$refs[`menuNavbarOption${option.id}`]
				if (this.$refs.menuNavbar && optionRef && optionRef[0]) {
					this.$refs.menuNavbar.scrollTo({
						left: optionRef[0].offsetLeft - 70,
						behavior: "smooth"
					})
				}
			}
		},
		openFilterModal() {
			let filterData = {
				tabs: this.options,
				title: this.$store.state.business.name
			}
			this.$refs.filterModal.open(filterData)
		}
	}
}
</script>